import { render, staticRenderFns } from "./AppearanceGroup.vue?vue&type=template&id=3774898b&scoped=true&"
import script from "./AppearanceGroup.vue?vue&type=script&lang=js&"
export * from "./AppearanceGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppearanceGroup.vue?vue&type=style&index=0&id=3774898b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774898b",
  null
  
)

export default component.exports